define('tweets',[],function() {

  var spans = [].slice.call(document.querySelectorAll(".tweet"));
  var template = "<a href=\"{url}\">{content}<i class=\"fa fa-twitter\"></i></a>";

  var clickSpan = function(e) {
    e.preventDefault();
    window.open(this.href, "_blank", "width=640,height=480,menubar=0,toolbar=0,location=0");
  };

  spans.forEach(function(span) {
    var text = span.getAttribute("text") || span.innerHTML;
    //warn on verbosity
    if (text.length > 100 && console && console.warn) {
      console.warn("This tweet may be too long: ", span);
    }
    var content = span.innerHTML;
    var url = "https://twitter.com/intent/tweet?";
    var query = [
      "text=" + encodeURI(text),
      "url=" + encodeURI(window.location.href),
      "via=seattletimes"
    ].join("&");
    span.innerHTML = template.replace("{url}", url + query).replace("{content}", content);
    span.querySelector("a").addEventListener("click", clickSpan);
  });

});
